// extracted by mini-css-extract-plugin
export default {"title":"Y_-z","warning":"Z_-z","sizeOptionsLegendText":"__-z"};